import { Component, Input, OnInit } from '@angular/core';

import { ChipVariant } from './chip-variant.model';

@Component({
	selector: 'app-chip',
	styleUrl: './chip.component.scss',
	templateUrl: './chip.component.html',
})
export class ChipComponent implements OnInit {
	@Input() font: string | null = null;
	@Input() variant: ChipVariant | null = null; // Classe para estilizar a fonte separadamente

	chipCssClass = '';
	fontCssClass = '';

	ngOnInit(): void {
		if (this.variant) {
			this.chipCssClass = `chip-${this.variant}`; // Classe do chip (cor de fundo)
		}

		if (this.font) {
			this.fontCssClass = `font-${this.font}`; // Classe do chip (cor da fonte)
		}
	}
}
